<template>
  <addFamilyTemplate
    :is-toc-visible="false"
    :header="header"
  >
    <template #content>
      <v-layout
        justify-center
        :pt-4="$vuetify.breakpoint.mdAndUp"
      >
        <v-flex xs10>
          <p class="f-2 fw-600 mb-1">
            {{ $t('outside_family.start_info.welcome') }}
          </p>
          <p class="f-1 font-weight-medium mb-0">
            {{ $t('outside_family.start_info.subtitle') }}
          </p>
          <p class="f-1 font-weight-medium mb-4">
            {{ $t('outside_family.start_info.subtitle_2') }}
          </p>

          <ol class="mt-2">
            <li
              v-for="(item, index) in $t('outside_family.start_info.steps')"
              :key="index"
              class="mb-0"
            >
              <p
                v-if="isObject(item)"
                class="mb-0 f-1"
              >
                <component
                  :is="text?.href ? 'a' : 'span'"
                  v-for="(text, index) in item"
                  :key="`text-${index}`"
                  :class="text?.class"
                  :href="text?.href"
                  :target="text?.href ? '_blank' : undefined"
                >
                  {{ text?.copy }}
                </component>
              </p>
              <p
                v-else
                class="mb-0 f-1"
              >
                {{ item }}
              </p>
            </li>
          </ol>

          <p class="f-3 font-weight-bold mt-2">
            {{ $t('outside_family.start_info.cta.text_1') }}
          </p>
          <ul>
            <li
              v-for="(item, index) in $t('outside_family.start_info.cta.bullet_points')"
              :key="index"
              class="f-3 font-weight-bold"
            >
              {{ item }}
            </li>
          </ul>
          <p class="f-3 font-weight-bold mt-2 mb-0">
            {{ $t('outside_family.start_info.cta.text_2') }}
          </p>
        </v-flex>
      </v-layout>
    </template>
    <template #actions>
      <v-layout
        align-center
        justify-center
        wrap
      >
        <v-flex
          shrink
          :mr-4="$vuetify.breakpoint.smAndUp"
          order-xs2
          order-sm1
          :mt-2="$vuetify.breakpoint.xs"
        >
          <a href="https://www.szlachetnapaczka.pl/">{{ $t('outside_family.return_to_szp') }}</a>
        </v-flex>
        <v-flex
          shrink
          order-xs1
          order-sm2
        >
          <v-btn
            :to="{ name: 'family-reporter-external' }"
            color="sz_violet"
          >
            {{ $t('outside_family.start_adding_button') }}
          </v-btn>
        </v-flex>
      </v-layout>
    </template>
  </addFamilyTemplate>
</template>

<script>
import AddFamilyTemplate from '@/components/addFamily/AddFamilyTemplate';

import isObject from 'lodash.isobject';

export default {
    name: 'WelcomeInfo',
    components: { AddFamilyTemplate },
    computed: {
        header () {
            return {
                title: this.$t('outside_family.start_info.title'),
                subtitle: null,
                redirect: true
            };
        },
        xsOnly () {
            return this.$vuetify.breakpoint.xsOnly;
        },
        baseUrl () {
            return process.env.BASE_URL;
        }
    },
    methods: {
        isObject (item) {
            return isObject(item);
        }
    }
};
</script>

<style scoped>
.steps-arrow-icon {
  background: no-repeat left/20px url('@/assets/svg/arrow-forward.svg');
  padding-left: 25px;
  margin-left: 2%;
}
</style>
